import { Input, LoadingSpinner, Pagination, Table } from "@/components";
import { HiOutlineSearch } from "react-icons/hi";
import { KEYS_SEARCH_PARAMS, useUsersInStore } from "../hooks";
import { CreateUser } from "./CreateUser";
import { RoleEnum, RoleManagerExcute } from "@/types";
import { useAuth } from "@/contexts/AuthContext";

const UsersInStore = ({
  companyId,
  companyName,
  storeStatus,
}: {
  companyId?: number;
  companyName?: string;
  storeStatus?: "ENABLE" | "DISABLE";
}) => {
  const {
    inputValue,
    setInputValue,
    handleUsersKeyDown,
    usersColumns,
    currentPage,
    updateSearchParams,
    usersInStore,
    loading,
    id,
    isDisabled,
  } = useUsersInStore({ storeStatus });
  const { role } = useAuth();

  return (
    <div className="flex-1 flex flex-col space-y-6">
      <section className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-between mb-4">
          {/* Left: title + search */}
          <div className="flex items-center space-x-3 flex-1 min-w-0">
            <h3 className="font-semibold whitespace-nowrap">店員一覧</h3>
            <div className="flex-1"></div>
            <Input
              placeholder="ユーザーを検索"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className="max-w-80 !h-9 placeholder:text-grey-600 pr-4 !pl-[38px]"
              classNameIcon="left-4"
              icon={
                <HiOutlineSearch className="w-[14.575px] h-[14.575px] text-action_light_active" />
              }
              onKeyDown={handleUsersKeyDown}
            />
          </div>
          {/* Right: button */}
          <div className="flex items-center space-x-3 ml-4">
            {RoleManagerExcute.USER_IN_STORE.CREATE[role || RoleEnum.OTHER] && (
              <CreateUser
                storeId={id}
                companyId={companyId}
                companyName={companyName}
                disabled={isDisabled}
              />
            )}
          </div>
        </div>
        {loading && !usersInStore?.data?.length ? (
          <LoadingSpinner className="py-20" />
        ) : (
          <Table
            columns={usersColumns}
            dataSource={usersInStore.data || []}
            rowKey="id"
            bordered={true}
            size="middle"
            className="visible-scrollbar"
          />
        )}

        {/* Pagination */}
        <div className="mt-4 flex justify-start">
          <Pagination
            currentPage={currentPage}
            totalPages={usersInStore.pagination?.pageCount || 0}
            onPageChange={(page: number) => {
              updateSearchParams({
                [KEYS_SEARCH_PARAMS.PAGE]: page.toString(),
              });
            }}
          />
        </div>
      </section>
    </div>
  );
};

export { UsersInStore };
